import { ApiRequest, GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/email-templates'

const baseFunctions = GetBaseServiceFunctions(BaseRoute)

function resetTemplateToDefault(templateKey, tenantId = null) {
  const tenantParam = tenantId ? `&tenantId=${tenantId}` : ''
  return ApiRequest.post(
    `${BaseRoute}/resetToDefault?templateKey=${templateKey}${tenantParam}`
  )
}

function resetContentToDefault(templateKey, tenantId = null) {
  const tenantParam = tenantId ? `&tenantId=${tenantId}` : ''
  return ApiRequest.post(
    `${BaseRoute}/removeTenantTextTemplate?templateKey=${templateKey}${tenantParam}`
  )
}

function setActive(templateKey, isActive) {
  return ApiRequest.put(
    `${BaseRoute}/${templateKey}/active?isActive=${isActive}`
  )
}

function resetHostEmailTemplates() {
  return ApiRequest.post(`${BaseRoute}/resetHostEmailTemplates`)
}

function getTenantEditedTemplate(templateKey) {
  return ApiRequest.get(
    `${BaseRoute}/getEditedTenantTemplates?templateKey=${templateKey}`
  )
}

function validateTemplate(templateKey, data = {}, tenantId = null) {
  const tenantParam = tenantId ? `?tenantId=${tenantId}` : ''
  return ApiRequest.post(
    `${BaseRoute}/${templateKey}/validate${tenantParam}`,
    data
  )
}

function getDisabledTemplates() {
  return ApiRequest.get(`${BaseRoute}/disabledTemplates`)
}

/**
 * Email templates an offshore staff member is allowed to see. Returned to every caller; only
 * applied when the current user is offshore staff.
 */
function getOffshoreVisibleTemplates() {
  return ApiRequest.get(`${BaseRoute}/offshoreVisibleTemplates`)
}

// ─── Tenant template drift (Host-only) ──────────────────────────────────────
function getDriftReport(tenantId) {
  return ApiRequest.get(`${BaseRoute}/drift-report?tenantId=${tenantId}`)
}

function getDriftDetail(tenantId, templateKey) {
  return ApiRequest.get(
    `${BaseRoute}/drift-detail?tenantId=${tenantId}&templateKey=${encodeURIComponent(
      templateKey
    )}`
  )
}

// Host cập nhật template trong ngữ cảnh của một tenant cụ thể.
function updateForTenant(templateKey, data, tenantId) {
  return ApiRequest.put(
    `${BaseRoute}/${templateKey}?tenantId=${tenantId}`,
    data
  )
}

const API = {
  ...baseFunctions,
  setActive,
  resetTemplateToDefault,
  resetContentToDefault,
  resetHostEmailTemplates,
  getTenantEditedTemplate,
  validateTemplate,
  getDisabledTemplates,
  getOffshoreVisibleTemplates,
  getDriftReport,
  getDriftDetail,
  updateForTenant,
}

export default API
